import React from 'react';
import '../styles/Content.css';
import { track } from '../lib/analytics';

const Contact = () => {
  return (
    <section id="contact" className="section section-card">
      <div className="section-head">
        <h2 className="section-title">Contact</h2>
        <p className="section-subtitle">Everything reachable from one clean surface.</p>
      </div>

      <div className="contact-list">
        <a
          className="contact-row"
          href="mailto:hello@ipavlidakis.dev"
          onClick={() => {
            track('contact_click', {
              surface: 'contact_section',
              section: 'contact',
              contact_method: 'email',
            });
          }}
        >
          <span className="contact-key">Email</span>
          <span className="contact-val">hello@ipavlidakis.dev</span>
        </a>
      </div>
    </section>
  );
};

export default Contact;
